export const DIVERGENCE_POPUP_STORAGE_KEY = "prism_launch_popup_seen_at";
export const DIVERGENCE_POPUP_EXPIRES_AT = "2026-10-01T23:59:59.999Z";

// Prepared for the post-launch switch on 2026-10-02. This copy is intentionally
// not rendered by the current Prism campaign and can be activated in one change.
export const POST_LAUNCH_POPUP = {
  kicker: "THREE FREE LAYERS",
  title: "Accumulate, Divergence and Blocks - free",
  body: "Already know the free layers? See what Prism does with them →",
  href: "/product#prism",
} as const;

function normalizePath(pathname: string) {
  const pathWithoutQueryOrHash = pathname.split("?")[0]?.split("#")[0] ?? "/";
  const normalized = pathWithoutQueryOrHash.replace(/\/+$/, "");
  return normalized || "/";
}

export function isDivergencePopupRoute(pathname: string) {
  const query = pathname.split("?")[1]?.split("#")[0] ?? "";
  if (new URLSearchParams(query).get("utm_campaign") === "prism_launch") return false;
  const path = normalizePath(pathname);
  return path === "/" || path === "/manual" || path === "/read" || path.startsWith("/read/") || path === "/free-tools" || path === "/education" || path.startsWith("/education/");
}

export function isDivergencePopupActive(now = new Date()) {
  return now.getTime() <= new Date(DIVERGENCE_POPUP_EXPIRES_AT).getTime();
}
